<template>
    <div>
        <div class="about">
            <div>
                <side-router menuName="leaseInstruction" />
            </div>
            <div class="routerCuttent">
               <transition name="no-mode-fade" mode="out-in">
                    <router-view />
                </transition>
            </div>
        </div>
    </div>
</template>

<script>

import sideRouter from '../side-router';
export default {
    components: { sideRouter },
    data() {
        return {
        }
    },

}
</script>
<style lang="scss" scoped>
.about {
    div {
        float: left;
    }
    .routerCuttent {
        margin: 25px 0 50px 0;
        width: 917px;
        background: #f6f5f5;
        box-shadow: 0px 0px 6px 1px #ccc;
        margin-left: 25px;
    }
}
</style>